import React from "react";

const capitalizeWords = (str = "") => {
  if (!str) return "";

  return str
    .trim()
    .split(/\s+/)    // removes extra spaces
    .map((word) =>
      word
        .split("-")  // handle hyphens
        .map((part) => 
          part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
        )
        .join("-")
    )
    .join(" ");
};

export default capitalizeWords;

